<template>
  <a-style-provider
    hash-priority="high"
    :transformers="[legacyLogicalPropertiesTransformer]"
  >
    <config-provider :locale="zhCN">
      <router-view />
    </config-provider>
  </a-style-provider>
</template>

<script lang="ts" setup>
import { ConfigProvider } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { legacyLogicalPropertiesTransformer } from 'ant-design-vue';
import { requestAuthCode } from 'dingtalk-jsapi';
import { onMounted, ref } from 'vue';
import { env } from 'dingtalk-jsapi/core';
import { ENV_ENUM } from 'dingtalk-jsapi/lib/env';
import { userApi } from '@/api/request/user';
import { dingtalkApi } from '@/api/request/dingtalk';
import { useAppStore } from '@/store/appStore.ts';
import router from '@/router';
import { useNexusEnv } from '@/hooks/useNexusEnv.ts';
import { setPlatformSession } from '@/utils/login';

const isDingtalk = ref(true);

onMounted(() => {
  isDingtalk.value =
    process.env.NODE_ENV === 'development'
      ? true
      : env.platform !== ENV_ENUM.notInDingTalk;

  if (isDingtalk.value) {
    autoLogin();
  }
});

const appStore = useAppStore();

// nexus 展示环境跳板：宿主 setEnv 后静默 demo 登录并跳转 web-v2（见 useNexusEnv）
useNexusEnv();

async function autoLogin() {
  if (env.platform === ENV_ENUM.notInDingTalk) return;
  const { code } = await requestAuthCode({
    corpId: import.meta.env.VITE_DINGTALK_CORP_ID,
    clientId: import.meta.env.VITE_DINGTALK_CLIENT_ID,
  });

  const { data } = await userApi.loginWithCode(code);
  appStore.setLoginState(data.data);

  // platform 会话随 OTA 免登响应下发（OTA 后端经受信子系统 exchange 换发，
  // 替代旧 unionId → sign_union_id 重签的冒充链路）
  setPlatformSession(data.data.platform_session);

  await router.push('/');
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  display: flex;
  //padding: 8px;
  background-color: #f0f2f5;
}

* {
  margin: 0;
  padding: 0;
}

@media (max-width: 1014px) {
  .ant-form-item-label {
    line-height: 40px !important;
  }

  .hideMobile {
    display: none !important;
  }

  .showMobile {
    display: inline-block !important;
  }
}

@media (min-width: 1015px) {
  .hideMobile {
    display: inline-block !important;
  }

  .showMobile {
    display: none !important;
  }
}
</style>
